import React from 'react'

export default function Header() {
  return (
    <>
      <h1>Ajay Bhattacharyya</h1>
      <h3>Senior Software Engineer</h3>
    </>
  )
}
